<template>
    <div v-if="listready" class="wrapper">
        <div class="animated fadeIn">
            <b-card header="<i class='fa fa-align-justify'></i><strong> Belichtingssoorten</strong>">
                <item-list
                        :items="items"
                        @delete-item="deleteItem">
                </item-list>
            </b-card>
        </div>

        <b-modal title="Verwijderen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Deze belichtingssoort kan niet verwijderd worden! Deze belichtingssoort wordt nog gebruikt. {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/soortbelichting';
    import ItemList from './List';

    export default {
        data () {
            return {
                warningModal: false,
                listready: false,
                errormsg: '',
                items: [],
            };
        },
        created () {
            this.getItems();
        },
        methods: {
            getItems () {
                api.getListSoortbelichting().then((response) => {
                    this.items = response.data;
                    this.listready = true;
                });
            },
            deleteItem (id) {
                api.deleteSoortbelichting(id).then(() => {
                    this.getItems();
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-list': ItemList,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/soortbelichting/Index.vue